import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import SearchLookupControl from "../../components/SearchLookupControl";

const Inquiry = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [lovValue, setLovValue] = useState("Order No");
  const [searchInput, setSearchInput] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [receiptData, setReceiptData] = useState([]);
  const [lookupValue, setLookupValue] = useState(null);

  const handleSearch = () => {
    // Simulate API result
    if (lovValue === "Order No") {
      setOrderData([
        { id: 1, orderNumber: searchInput || "ORD-001", date: "2024-01-01", status: "Shipped" },
      ]);

      if (lovValue === "Receipt") {
        setReceiptData([
          {
            id: 1,
            receiptNumber: searchInput || "REC-123",
            amount: 500,
            date: "2024-01-03",
          },
        ]);
      }
    }
  };

  const orderColumns = [
    { field: "orderNumber", headerName: "Order No", flex: 1 },
    { field: "date", headerName: "Date", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
  ];

  const receiptColumns = [
    { field: "receiptNumber", headerName: "Receipt No", flex: 1 },
    { field: "amount", headerName: "Amount", flex: 1, type: "number" },
    { field: "date", headerName: "Date", flex: 1 },
  ];

  return (
    <Box m={2}>
      <Header title="Inquiry" />

    
        <SearchLookupControl
          label="Search Value"
          lookupName={lovValue}   // e.g. "Invoice", "Receipt"
          type="NUMBER"           // or whatever your backend expects
          value={lookupValue}
          onChange={(val) => setLookupValue(val)}
          apiUrl="http://your-api/lookup"
        />
   

      {/* Search Bar */}
      <Box display="flex" alignItems="center" gap={2} mb={4} flexWrap="wrap">
        <TextField
          select
          label="LOV"
          value={lovValue}
          onChange={(e) => setLovValue(e.target.value)}
          size="small"
          sx={{ minWidth: 250 }}
        >
          <MenuItem value="Invoice">Invoice</MenuItem>
          <MenuItem value="Receipt">Receipt</MenuItem>
          <MenuItem value="Order No">Order No</MenuItem>
          <MenuItem value="Delivery No">Delivery No</MenuItem>
          <MenuItem value="CR No">CR No</MenuItem>
        </TextField>

        {/* Dynamic Input Field */}
        <TextField
          label={
            lovValue === "CR No"
              ? "Enter CR No"
              : `Enter ${lovValue}`
          }
          placeholder={`Enter ${lovValue}`}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          size="small"
          sx={{ minWidth: 250 }}
        // disabled={!searchInput}
        />

        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: "#fff",
            minWidth: 150,
            height: "40px",
          }}
        >
          Search
        </Button>
      </Box>

      {/* Side-by-Side Grids */}
      <Box display="flex" gap={4}>
        {/* Order No Grid */}
        <Box flex={1}>
          <Typography variant="h6" gutterBottom>
            Order No
          </Typography>
          <Box
            sx={{
              height: 300,
              backgroundColor: colors.primary[400],
              borderRadius: 1,
            }}
          >
            <DataGrid
              rows={orderData}
              columns={orderColumns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
            />
          </Box>
        </Box>

        {/* Receipt No Grid */}
        <Box flex={1}>
          <Typography variant="h6" gutterBottom>
            Receipt No
          </Typography>
          <Box
            sx={{
              height: 300,
              backgroundColor: colors.primary[400],
              borderRadius: 1,
            }}
          >
            <DataGrid
              rows={receiptData}
              columns={receiptColumns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Inquiry;